import { TOAST_UPDATE_PERSONAL_INFO } from '@/constants/toast';
import { useStartUpdateUserCredential } from '@/queries/user.queries';
import { useToast } from '@cmpsr/components';
import { useForm } from 'react-hook-form';
import { OnDone } from '../../edit-email-address.controller';

export default function useModalUpdateEmailController(onDone: OnDone<string>) {
  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      newEmail: '',
      confirmNewEmail: '',
    },
  });

  const startUpdateCredentialMutation = useStartUpdateUserCredential();
  const toast = useToast();

  const validateEmailsMatch = (value: string) => {
    const newEmailValue = form.getValues('newEmail');
    return (
      value === newEmailValue ||
      'The email addresses do not match each other, please verify that they are correct and try again.'
    );
  };

  const handleSubmit = form.handleSubmit((values) => {
    startUpdateCredentialMutation
      .mutateAsync({ credential: values.newEmail })
      .then(() => {
        onDone(values.newEmail);
      })
      .catch((error) => {
        console.error(error);
        let errorMessage = '';
        switch (error.response?.status) {
          case 409:
            errorMessage = 'This email address is already in use, please try another one.';
            break;
          default:
            errorMessage = error.response?.data?.message ?? error.message;
            break;
        }
        toast({
          ...TOAST_UPDATE_PERSONAL_INFO,
          description: errorMessage,
          status: 'error',
        });
      });
  });

  return {
    form,
    validateEmailsMatch,
    handleSubmit,
  };
}
